import {Button, Col, Descriptions, Dropdown, Form, Input, Avatar, Row, MenuProps} from 'antd';
import {LogoutOutlined, UserOutlined} from '@ant-design/icons';
import Modal from 'antd/lib/modal/Modal';
import {useState} from 'react';
import {useAppDispatch, useAppSelector} from '../../common/hooks';
import {logout} from '../auth/authSlice';
import {userPasswordUpdate} from './configSlice';

const ProfileAvatar = () => {
  const [form] = Form.useForm();
  const state = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector((state) => state.config.isLoading);

  const userAvatar = state.user.details.name[0].toUpperCase();
  const [isPasswordChanging, setIsPasswordChanging] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSubmit = (values: {password: string; confirm: string}) => {
    dispatch(userPasswordUpdate({password: values.password}))
      .unwrap()
      .then(() => {
        setIsModalOpen(false);
        setIsPasswordChanging(false);
      });
  };
  const itemsAvatar: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <p
          onClick={() => setIsModalOpen(true)}
          style={{
            paddingInline: '10px',
            margin: '0px',
          }}
        >
          <UserOutlined /> <span style={{paddingLeft: '10px'}}>Profile</span>
        </p>
      ),
    },
    {
      key: '2',
      label: (
        <a
          style={{paddingInline: '10px'}}
          href='/login'
          onClick={() => {
            dispatch(logout());
          }}
        >
          <LogoutOutlined rotate={-90} /> <span style={{paddingLeft: '10px'}}>Logout</span>
        </a>
      ),
    },
  ];

  return (
    <>
      <Dropdown menu={{items: itemsAvatar}}>
        <Avatar style={{backgroundColor: '#fde3cf', cursor: 'default', color: '#f56a00'}} size={40}>
          {userAvatar}
        </Avatar>
      </Dropdown>

      <Modal
        maskClosable={false}
        title='User Profile Information'
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={
          !isPasswordChanging
            ? [
                <Button
                  key='back'
                  type='primary'
                  onClick={() => {
                    setIsPasswordChanging(true);
                  }}
                >
                  Edit Password
                </Button>,
              ]
            : [
                <Button
                  type='primary'
                  key='1'
                  onClick={() => {
                    form.validateFields().then((values) => {
                      handleSubmit(values);
                    });
                  }}
                  loading={isLoading}
                >
                  Set Password
                </Button>,
                <Button key='2' type='primary' danger onClick={() => setIsPasswordChanging(false)}>
                  Cancel
                </Button>,
              ]
        }
      >
        <Descriptions column={1} bordered>
          <Descriptions.Item label='Username'>{state.user.details.username}</Descriptions.Item>
          <Descriptions.Item label='Display Name'>{state.user.details.name}</Descriptions.Item>
          <Descriptions.Item label='Email'> {state.user.details.email} </Descriptions.Item>
          <Descriptions.Item label='Phone Number'>{state.user.details.phone}</Descriptions.Item>
        </Descriptions>

        {isPasswordChanging && (
          <Row style={{marginTop: '30px'}}>
            <strong>Edit Password:</strong>
            <Col span={24}>
              <Form form={form} name='register'>
                <Form.Item
                  name='password'
                  rules={[
                    {
                      required: true,
                      min: 4,
                      message: 'Please input your password!',
                    },
                  ]}
                >
                  <Input.Password placeholder='Password' />
                </Form.Item>
              </Form>
            </Col>
          </Row>
        )}
      </Modal>
    </>
  );
};

export default ProfileAvatar;
